// features/licenses/reducer.ts
import type { LicenseRow, LicensesState } from "./types";

export type Action =
  | { type: "LOAD_STARTED" }
  | { type: "LOAD_SUCCEEDED"; payload: LicenseRow[] }
  | { type: "LOAD_FAILED"; error: string }
  | { type: "SELECT_SET"; id?: number; row?: LicenseRow | null }
  | { type: "MANAGEMENT_DRAWER_OPEN_SET"; open: boolean }
  | { type: "CANCEL_MAIN_LICENSE_STARTED" }
  | { type: "CANCEL_MAIN_LICENSE_SUCCEEDED"; id: number }
  | { type: "CANCEL_MAIN_LICENSE_FAILED"; error: string };
;

export function licensesReducer(state: LicensesState, action: Action): LicensesState {
  switch (action.type) {
    case "LOAD_STARTED":
      return { ...state, loading: true, error: null };

    case "LOAD_SUCCEEDED": {
      const rows = action.payload;
      const selected = state.selected
        ? rows.find((r) => r.Id === state.selected.Id) ?? null
        : null;
      return { ...state, loading: false, data: rows, selected };
    }

    case "LOAD_FAILED":
      return { ...state, loading: false, error: action.error };

    case "SELECT_SET": {
      const next =
        typeof action.id !== "undefined"
          ? state.data.find((r) => r.Id === action.id) ?? null
          : action.row ?? null;
      return { ...state, selected: next };
    }

    case "MANAGEMENT_DRAWER_OPEN_SET":
      return { ...state, managementDrawerOpen: action.open };


    case "CANCEL_MAIN_LICENSE_STARTED":
      return { ...state, loadingCancelMainLicense: true, error: null };
    case "CANCEL_MAIN_LICENSE_SUCCEEDED": {
      const rows = state.data.filter((r) => r.Id !== action.id);
      const selected = state.selected?.Id === action.id ? null : state.selected;
      return { ...state, loadingCancelMainLicense: false, data: rows, selected };
    }
    case "CANCEL_MAIN_LICENSE_FAILED":
      return { ...state, loadingCancelMainLicense: false, error: action.error };

    default:
      return state;
  }
}
